"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ziweiMaj: '紫微',
    tianjiMaj: '天機',
    taiyangMaj: '太陽',
    wuquMaj: '武曲',
    tiantongMaj: '天同',
    lianzhenMaj: '廉貞',
    tianfuMaj: '天府',
    taiyinMaj: '太陰',
    tanlangMaj: '貪狼',
    jumenMaj: '巨門',
    tianxiangMaj: '天相',
    tianliangMaj: '天梁',
    qishaMaj: '七殺',
    pojunMaj: '破軍',
    zuofuMin: '左輔',
    youbiMin: '右弼',
    wenchangMin: '文昌',
    wenquMin: '文曲',
    lucunMin: '祿存',
    tianmaMin: '天馬',
    qingyangMin: '擎羊',
    tuoluoMin: '陀羅',
    huoxingMin: '火星',
    lingxingMin: '鈴星',
    tiankuiMin: '天魁',
    tianyueMin: '天鉞',
    dikongMin: '地空',
    dijieMin: '地劫',
    jieshaAdj: '劫殺',
    tiankong: '天空',
    tianxing: '天刑',
    tianyao: '天姚',
    jieshen: '解神',
    yinsha: '陰煞',
    tianxi: '天喜',
    tianguan: '天官',
    tianfu: '天福',
    tianku: '天哭',
    tianxu: '天虛',
    longchi: '龍池',
    fengge: '鳳閣',
    hongluan: '紅鸞',
    guchen: '孤辰',
    guasu: '寡宿',
    feilian: '蜚廉',
    posui: '破碎',
    taifu: '台輔',
    fenggao: '封誥',
    tianwu: '天巫',
    tianyue: '天月',
    santai: '三台',
    bazuo: '八座',
    engguang: '恩光',
    tiangui: '天貴',
    tiancai: '天才',
    tianshou: '天壽',
    jiekong: '截空',
    xunzhong: '旬中',
    xunkong: '旬空',
    kongwang: '空亡',
    jielu: '截路',
    yuede: '月德',
    tianshang: '天傷',
    tianshi: '天使',
    tianchu: '天廚',
    changsheng: '長生',
    muyu: '沐浴',
    guandai: '冠帶',
    linguan: '臨官',
    diwang: '帝旺',
    shuai: '衰',
    bing: '病',
    si: '死',
    mu: '墓',
    jue: '絕',
    tai: '胎',
    yang: '養',
    boshi: '博士',
    lishi: '力士',
    qinglong: '青龍',
    xiaohao: '小耗',
    jiangjun: '將軍',
    zhoushu: '奏書',
    faylian: '飛廉',
    xishen: '喜神',
    bingfu: '病符',
    dahao: '大耗',
    suipo: '歲破',
    fubing: '伏兵',
    guanfu: '官府',
    suijian: '歲建',
    huiqi: '晦氣',
    sangmen: '喪門',
    guansuo: '貫索',
    gwanfu: '官符',
    longde: '龍德',
    baihu: '白虎',
    tiande: '天德',
    diaoke: '弔客',
    jiangxing: '將星',
    panan: '攀鞍',
    suiyi: '歲驛',
    xiishen: '息神',
    huagai: '華蓋',
    jiesha: '劫煞',
    zhaisha: '災煞',
    tiansha: '天煞',
    zhibei: '指背',
    xianchi: '咸池',
    yuesha: '月煞',
    wangshen: '亡神',
    yunkui: '運魁',
    yunyue: '運鉞',
    yunchang: '運昌',
    yunqu: '運曲',
    yunluan: '運鸞',
    yunxi: '運喜',
    yunlu: '運祿',
    yunyang: '運羊',
    yuntuo: '運陀',
    yunma: '運馬',
    liukui: '流魁',
    liuyue: '流鉞',
    liuchang: '流昌',
    liuqu: '流曲',
    liuluan: '流鸞',
    liuxi: '流喜',
    liulu: '流祿',
    liuyang: '流羊',
    liutuo: '流陀',
    liuma: '流馬',
    nianjie: '年解',
    yuekui: '月魁',
    yueyue: '月鉞',
    yuechang: '月昌',
    yuequ: '月曲',
    yueluan: '月鸞',
    yuexi: '月喜',
    yuelu: '月祿',
    yueyang: '月羊',
    yuetuo: '月陀',
    yuema: '月馬',
    rikui: '日魁',
    riyue: '日鉞',
    richang: '日昌',
    riqu: '日曲',
    riluan: '日鸞',
    rixi: '日喜',
    rilu: '日祿',
    riyang: '日羊',
    rituo: '日陀',
    rima: '日馬',
    shikui: '時魁',
    shiyue: '時鉞',
    shichang: '時昌',
    shiqu: '時曲',
    shiluan: '時鸞',
    shixi: '時喜',
    shilu: '時祿',
    shiyang: '時羊',
    shituo: '時陀',
    shima: '時馬',
};
